import { SnackbarTypes } from './snackbar.reducer';
import { actionCreatorFactory } from 'typescript-fsa';
const actionCreator = actionCreatorFactory('InfoSnackbar');

export const showSnackbar = actionCreator<{
  message: string;
  type: SnackbarTypes;
}>('SNACKBAR_SHOW');

export const hideSnackbar = actionCreator('SNACKBAR_HIDE');



// WEBPACK FOOTER //
// ./src/store/Snackbar/snackbar.actions.ts